import { Check } from 'lucide-react';
import { motion } from 'framer-motion';

type Props = {
  label: string;
  selected: boolean;
  onClick: () => void;
  multiple?: boolean;
};

export function ChoiceCard({ label, selected, onClick, multiple = false }: Props) {
  return (
    <motion.button
      type="button"
      className={`choice-card ${selected ? 'selected' : ''}`}
      onClick={onClick}
      whileTap={{ scale: 0.97 }}
      aria-pressed={selected}
    >
      <span>{label}</span>
      <span className="choice-check" aria-hidden="true">
        {selected ? <Check size={16} /> : multiple ? '+' : '○'}
      </span>
    </motion.button>
  );
}
